import classnames from "classnames";
import React from "react";

import { Content } from "../../types/content.types";

type CallToActionContentProps = Content;

const CallToActionContent = ({
    text,
    iconClassName,
    iconPosition,
}: CallToActionContentProps) => (
    <>
        {iconClassName && iconPosition === "start" && (
            <i
                className={classnames("las la-lg mr-2", `la-${iconClassName}`)}
            />
        )}
        {text}
        {iconClassName && iconPosition === "end" && (
            <i
                className={classnames("las la-lg ml-2", `la-${iconClassName}`)}
            />
        )}
    </>
);

export { CallToActionContent };
